export var strawberry = {
  start: 'var(--cds-color-yellow-500, #fc6e51)',
  end: 'var(--cds-color-red-600, #da4453)',
  deg: 90
};
export var peach = {
  start: 'var(--cds-color-yellow-500, #fc6e51)',
  end: 'var(--cds-color-yellow-300, #f6bb42)',
  deg: 90
};
export var pear = {
  start: 'var(--cds-color-yellow-200, #ffce54)',
  end: 'var(--cds-color-green-500, #8cc152)',
  deg: 90
};
export var kiwi = {
  start: 'var(--cds-color-green-400, #a0d468)',
  end: 'var(--cds-color-green-400, #37bc9b)',
  deg: 90
};
export var sea = {
  start: 'var(--cds-color-green-300, #48cfad)',
  end: 'var(--cds-color-blue-300, #3bafda)',
  deg: 90
};
export var coursera = {
  start: 'var(--cds-color-blue-300, #4fc1e9)',
  end: 'var(--cds-color-blue-500, #4a89dc)',
  deg: 90
};
export var blueberry = {
  start: 'var(--cds-color-blue-400, #5d9cec)',
  end: 'var(--cds-color-purple-400, #967adc)',
  deg: 90
};
export var grape = {
  start: 'var(--cds-color-purple-300, #ac92ec)',
  end: 'var(--cds-color-pink-400, #d770ad)',
  deg: 90
};
export var productCardSpecialization = {
  start: 'var(--cds-color-blue-700, #2965CA)',
  end: 'var(--cds-color-purple-700, #563BC2)',
  deg: 135
};